




















































































































  import { namespace } from 'vuex-class'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import { Cart, Shared } from '@one/types/dist/orderpath/app'
  import { AxiosResponse } from 'axios'
  import { Component, Prop, Watch, mixins } from 'nuxt-property-decorator'
  import { isNotNull } from '@one/core'
  import { StateChanger } from 'vue-infinite-loading'
  import UtilsMixin from '~/mixins/UtilsMixin'

  const layout: BindingHelpers = namespace('layout')
  const cart: BindingHelpers = namespace('cart')
  const stocks: BindingHelpers = namespace('stocks')

  export interface AwardProductChanged {
    id: string
    quantity: number
    shouldBeRemoved?: boolean
  }
  export interface AwardsUpdateEvent {
    awardsDeleted: Array<AwardProductChanged>
    awardsAdded: Array<AwardProductChanged>
    isMultiple?: boolean
  }
  export interface InitialAwards {
    id: string,
    selected: number,
    quantity: number
  }

  @Component({
    components: {
      OneIconLoader: () => import('~/components/molecules/icons/OneIconLoader.vue'),
      InfiniteLoading: () => import('vue-infinite-loading'),
    },
  })
  export default class OneCampaignModal extends mixins<UtilsMixin>(UtilsMixin) {
    isLoadError: boolean = false
    error: unknown = null
    selectedAwards: Array<string> = []
    promotion: Cart.Responses.CampaignAwardsRestView | null = null
    pageNumber: number = 1
    pageSize: number = 18
    availableAwards: Array<Shared.CampaignAwardRestView> = []
    initialAwards: Array<InitialAwards> = []
    hasNextPage: boolean = true
    productSearch: string = ''
    selectedAwardsAmount: number = 0
    awardsAdded: Array<string> = []
    awardsDeleted: Array<string> = []
    multipleChoice: boolean = false

    @cart.Getter getCurrentCartId: any
    @layout.Getter getCurrency: any;
    @layout.Getter isGrossSelected: any
    @stocks.Getter getDefaultWarehouseId: any

    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    progress!: boolean;

    @Prop({
      type: String,
      required: false,
      default: null,
    })
    campaignId!: string | null;

    @Prop({
      type: Number,
      required: false,
      default: 0,
    })
    initiallySelectedAwardsAmount!: number

    get isAwardsCountLimitReached() {
      return this.promotion!.available <= this.selectedAwards.length
    }

    get selectedMultipleAwardsAmount() {
      return Number(this.availableAwards
        .map(item => item.selected)
        .reduce((prev, next) => Number(prev) + Number(next), 0),
      )
    }

    get isTooMuchAwardsSelected() {
      return this.multipleChoice && this.selectedMultipleAwardsAmount > this.promotion!.available
    }

    get selectedPromotionsCounter() {
      return this.multipleChoice
        ? `${this.selectedMultipleAwardsAmount}/${this.promotion?.available}`
        : `${this.selectedAwardsAmount}/${this.promotion?.available}`
    }

    getProductQuantity(id: string) {
      return this.availableAwards.find(award => award.id === id)!.quantity
    }

    get price() {
      return (product: Shared.CampaignAwardRestView) => {
        return this.isGrossSelected ? product.prices.contentUnitGross : product.prices.contentUnitNet
      }
    }

    get updatedAwards(): AwardsUpdateEvent {
      return {
        awardsDeleted: this.awardsDeleted.map((id:string) => {
          return this.awardsAdded.includes(id)
            ? null
            : {
              id: id,
              quantity: -(this.getProductQuantity(id)),
            }
        }).filter(isNotNull),
        awardsAdded: this.awardsAdded.map((id:string) => {
          return this.awardsDeleted.includes(id)
            ? null
            : {
              id: id,
              quantity: this.getProductQuantity(id),
            }
        }).filter(isNotNull),
      }
    }

    get updatedMultipleAwards() {
      const newSelectedAwards = this.availableAwards.filter((award) => {
        if (award.selected) {
          return this.initialAwards.find((item) => {
            return award.id === item.id && award.selected > item.selected
          })
        }
        return false
      })

      const productsToAdd = newSelectedAwards.map((award) => {
        return {
          id: award.id,
          quantity: this.calculateProductsQuantity(award),
        }
      })

      const unselectedAwards = this.availableAwards.filter((award) => {
        return this.initialAwards.find((item) => {
          return award.id === item.id && award.selected < item.selected
        })
      })

      const productsToRemove = unselectedAwards.map((award) => {
        return {
          id: award.id,
          quantity: Math.abs(this.calculateProductsQuantity(award)),
          shouldBeRemoved: !award.selected,
        }
      })

      return {
        isMultiple: true,
        awardsAdded: productsToAdd,
        awardsDeleted: productsToRemove,
      }
    }

    calculateProductsQuantity(award: Shared.CampaignAwardRestView) {
      return (Number(award.selected) - Number(this.initialAwards.find(item => item.id === award.id)?.selected)) * award.quantity
    }

    onCheckboxChange(value: string) {
      const indexKey = this.selectedAwards.indexOf(value)
      if (indexKey > -1) {
        this.awardsDeleted.push(value)

        const addedIndex = this.awardsAdded.indexOf(value)
        if (addedIndex > -1) { this.awardsAdded.splice(addedIndex, 1) }

        this.selectedAwardsAmount--
        this.selectedAwards.splice(indexKey, 1)
      } else if (!this.isAwardsCountLimitReached) {
        this.awardsAdded.push(value)

        const deletedIndex = this.awardsDeleted.indexOf(value)
        if (deletedIndex > -1) { this.awardsDeleted.splice(deletedIndex, 1) }

        this.selectedAwardsAmount++
        this.selectedAwards.push(value)
      }
    }

    onQuantityChange(award: Shared.CampaignAwardRestView, value: number) {
      if (!this.initialAwards.some(item => item.id === award.id)) {
        this.initialAwards = this.availableAwards.map((item) => {
          return {
            id: item.id,
            selected: Number(item.selected),
            quantity: item.quantity,
          }
        })
      }
      award.selected = value
    }

    onSave() {
      if (this.isTooMuchAwardsSelected) { return }
      this.$emit('saved', this.multipleChoice ? this.updatedMultipleAwards : this.updatedAwards)
    }

    isAwardSelected(id: string): boolean {
      return this.selectedAwards.includes(id)
    }

    onLoadError(error: unknown) {
      this.isLoadError = true
      this.error = error
    }

    isDisabled(isAwardSelected: boolean): boolean {
      return !isAwardSelected && this.isAwardsCountLimitReached
    }

    fetchAwards(infiniteScrollState: StateChanger | null) {
      if (this.campaignId && this.hasNextPage) {
        if (!infiniteScrollState) { this.$wait.start('fetch-awards') }
        this.$api.orderpath.app.getPaginatedAwardsForCart(this.getCurrentCartId, this.campaignId,
                                                          this.getDefaultWarehouseId, this.pageNumber, this.pageSize, this.productSearch)
          .then((res: AxiosResponse<Cart.Responses.CampaignAwardsRestView>) => {
            this.multipleChoice = res.data.multipleChoice
            this.promotion = res.data
            this.availableAwards.push(...this.promotion.awards.items)
            if (!this.promotion.awards.nextPage) {
              this.hasNextPage = false
              if (infiniteScrollState) { infiniteScrollState.complete() }
            } else {
              this.pageNumber++
              if (infiniteScrollState) { infiniteScrollState.loaded() }
            }

            this.selectedAwards.push(...this.promotion.awards.items
              .map((award: Shared.CampaignAwardRestView) => {
                return (award.selected && award.id) || null
              })
              .filter(isNotNull) ?? [])
          })
          .catch(this.onLoadError)
          .finally(() => this.$wait.end('fetch-awards'))
      }
    }

    getAwardPhoto(award: Shared.CampaignAwardRestView): string {
      return award?.photo || 'https://static-demo-images.s3-eu-west-1.amazonaws.com/photo_plcs_min.svg'
    }

    @Watch('productSearch', { immediate: true })
    // eslint-disable-next-line
    onProductSearchChange(newVal: any, oldVal: any) {
      if (typeof oldVal === 'undefined') { return }
      this.availableAwards = []
      this.hasNextPage = true
      this.pageNumber = 1
      this.fetchAwards(null)
    }

    @Watch('value', { immediate: true })
    onModalVisibilityChanged(isVisible: boolean) {
      if (isVisible) {
        this.selectedAwardsAmount = this.initiallySelectedAwardsAmount
      } else {
        this.availableAwards = []
        this.selectedAwards = []
        this.initialAwards = []
        this.hasNextPage = true
        this.pageNumber = 1
        this.awardsAdded = []
        this.awardsDeleted = []
        this.selectedAwardsAmount = 0
      }
    }
  }
